/* Copyright (C) mroads, LLC - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Premsagar Choudhary <premsagar.choudhary@mroads.com>, June 2023
 * @format
 * @flow
 */

import React from 'react';
import { useSelector } from 'react-redux';
import cn from 'classnames';
import { Box, IconButton, Select, FormControl, Icon } from '@material-ui/core';
import {
  Add as AddIcon,
  SaveOutlined as SaveOutlinedIcon,
  CancelOutlined as CancelOutlinedIcon,
} from '@material-ui/icons';
import useStyles from './useStyles';

const Header = ({
  onClose,
  onSave,
  onDeleteLayout,
  selectedSensorGrpId,
  onChangeSensorGroup,
  storeLayoutBySensorGroup,
  onStart,
}) => {
  const classes = useStyles();
  const { storeInfo, labelsData } = useSelector(state => state);
  const labels = labelsData?.labels;
  const { sensorGroups: sensorGrpArray } = storeInfo?.data || {};
  const sensorGroups = Array.isArray(sensorGrpArray)
    ? [{ id: -1, name: labels.DESIGNER_SELECT_SENSOR_GROUP }, ...sensorGrpArray]
    : [];

  return (
    <Box className={classes.root}>
      <Box className={classes.leftWrapper}>
        <IconButton className={cn(classes.iconButton, classes.primary)} onClick={onStart}>
          <AddIcon fontSize='medium' className={cn(classes.icon, classes.primaryIconColor)} />
        </IconButton>
        <IconButton onClick={onSave} className={cn(classes.iconButton)}>
          <SaveOutlinedIcon fontSize='medium' className={classes.icon} />
        </IconButton>
      </Box>
      {storeLayoutBySensorGroup && (
        <FormControl variant='outlined' size='small' className={classes.formControl}>
          <Select
            native
            value={selectedSensorGrpId}
            onChange={onChangeSensorGroup}
            inputProps={{
              style: {
                fontSize: '14px'
              }
            }}
          >
            {sensorGroups.map(sensorGrp =>
              <option key={`id-${sensorGrp.id}`} value={sensorGrp?.id} selected={selectedSensorGrpId === sensorGrp.id}>{sensorGrp?.name}</option>
            )}
          </Select>
        </FormControl>
      )}
      <Box className={classes.rightWrapper}>
        <IconButton onClick={onDeleteLayout} className={cn(classes.iconButton)}>
          <Icon className={cn(cn('material-icons-outlined', classes.icon))} fontSize='medium'>
            grid_off
          </Icon>
        </IconButton>
        <IconButton onClick={onClose} className={cn(classes.iconButton)}>
          <CancelOutlinedIcon fontSize='medium' className={classes.icon} />
        </IconButton>
      </Box>
    </Box>
  );
};

export default Header;
